<template>
	<section class="totalBox" v-show="viewShow">
		<pcView v-if="isPc" />
		<h5View v-else /> 
	</section>
</template>


<script> 
import { mapState } from 'vuex';  
import pcView from '@/components/signup/pc/index'
import h5View from '@/components/signup/v4/index'

export default {
	components:{},
	name: 'signup',
	data() {
		return { 
			
		};
	},
	components: {
		pcView,h5View
	},
	watch: { 
		
	}, 
	created() {  
	},
	mounted() {
		
	},
	computed: {
		isPc() { 
		  return this.$store.state.isPc;
		},
		viewShow(){
		  return this.$store.state.viewShow;
		}
	},
	computed: {
	  ...mapState(['isPc','viewShow'])
	},
};
</script>

<style lang="scss" scoped="scoped"> 
.totalBox{
	// width: 100vw; 
}
</style>
